"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("../dist/index");
(0, index_1.createAudioPlayer)('audio-player', 'https://archive.org/download/apotheosis-trailer/apotheosis-trailer.mp3')
    .withPlaylist('playlist');
//# sourceMappingURL=app.js.map